var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from 'class-transformer';
import { Record } from './Record.js';
export var NotificationType;
(function (NotificationType) {
    NotificationType["SCHEDULE"] = "SCHEDULE";
    NotificationType["ACTIVITY"] = "ACTIVITY";
})(NotificationType = NotificationType || (NotificationType = {}));
export class Notification extends Record {
    constructor() {
        super(...arguments);
        this.body = '';
        this.title = '';
        this.seen = false;
        this.created_at = new Date();
    }
}
__decorate([
    Type(() => Date)
], Notification.prototype, "created_at", void 0);
;
